import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { userActions } from '../_actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

class DeleteUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteUser() {
    console.log("DELETE");
    console.log(this.props.id);
    this.props.delete(this.props.id);
    this.toggle();
  }

  render() {
    return (
      <div>
        <Button color="danger" className="full-width" onClick={this.toggle}><FontAwesomeIcon icon={faTimes} color="white" size="lg" /></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader>Delete User</ModalHeader>
          <ModalBody>
            <div>Are you sure you want to delete this user?</div>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col>
                <Button color="danger" onClick={this.deleteUser}>Supprimer</Button>
              </Col>
              <Col xs="6" className="text-center" >
                <Button color="secondary" onClick={this.toggle}>Annuler</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    delete: (user) => {
      dispatch(userActions.delete(user.id))
    }
  }
}

const connectedDeleteUserModal = connect(mapStateToProps, mapDispatchToProps)(DeleteUserModal);
export { connectedDeleteUserModal as DeleteUserModal };
